import { motion } from "framer-motion";

const easing = [0.22, 1, 0.36, 1];

// Scroll-reveal wrapper. Fades + rises children into view once.
export function Reveal({ children, delay = 0, y = 28, className = "", ...rest }) {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.8, ease: easing, delay }}
      {...rest}
    >
      {children}
    </motion.div>
  );
}

// Line-by-line masked reveal for large display headlines.
export function MaskReveal({ lines, className = "", delay = 0 }) {
  return (
    <span className={className}>
      {lines.map((line, i) => (
        <span key={i} className="hero-line-mask">
          <motion.span
            className="block"
            initial={{ y: "110%" }}
            animate={{ y: "0%" }}
            transition={{ duration: 0.9, ease: easing, delay: delay + i * 0.12 }}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </span>
  );
}
